import React from 'react';
import {RegisterOptions} from 'react-hook-form';
import {t} from '@lingui/core/macro';

import {validateMultipleDomains} from 'shared/lib/validation/validateDomain';

import TextArea, {TextAreaProps} from './TextArea';

const TextAreaDomain: React.FC<TextAreaProps> = (props) => {
    const rules: RegisterOptions = {
        validate: validateMultipleDomains,
        required: t`Укажите хотя бы один домен`,
    };

    return (
        <TextArea
            constraints={rules}
            {...props}
        />
    );
};

export default TextAreaDomain;
